import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, AtualizarMunicipio } from './types';

export const INITIAL_STATE: AtualizarMunicipio = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): AtualizarMunicipio {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ATUALIZAR_MUNICIPIO_REQUEST: {
				draft.status = INITIAL_STATE.status;
				break;
			}

			case Types.ATUALIZAR_MUNICIPIO_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.ATUALIZAR_MUNICIPIO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.ATUALIZAR_MUNICIPIO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
